import React from 'react';

import './Buttons.css';

const Buttons = ({ fileType, resourceType, resultType, url, onClickLink }) => {
  const typeToButtonMap = {
    'Blog': 'Read More',
    'Services': 'Learn More',
    'Posters': 'Download Now',
    'About Us': 'Learn More',
    'White Papers': 'Download Now',
    'Application Notes': 'Download Now',
    'Quick Facts': 'Download Now',
    'Factsheets': 'Download Now',
    'Models': 'View Model',
    'Webinars': 'Watch Now',
    'Press Releases': 'Read More',
    'eBooks': 'Download Now',
  };

  const buttonText = typeToButtonMap[resultType] || typeToButtonMap[resourceType];
  console.log('fileType:', fileType);
  console.log('resourceType:', resourceType);
  console.log('resultType:', resultType);
  console.log('url:', url);
   console.log('buttonText:', buttonText);
  return (
    buttonText ? (
      <a href={url} target="_blank" rel="noopener noreferrer">
        <button onClick={onClickLink} className="search-cta-button">
          {buttonText}
        </button>
      </a>
    ) : null   // Ensure that null is returned if buttonText is not defined
  );
};

export default React.memo(Buttons);
